import PropTypes from 'prop-types';

export const SearchProps = PropTypes.shape({
  assetTypes: PropTypes.arrayOf(PropTypes.oneOf(['recarea', 'facility'])),
  activity: PropTypes.string,
  orgIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  state: PropTypes.string,
  terms: PropTypes.string,
  limit: PropTypes.number,
  page: PropTypes.number,
  sort: PropTypes.string
});

export const OptionProps = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});

export const SearchDefaults = {
  assetTypes: ['recarea', 'facility'],
  activity: null,
  orgIds: [],
  state: null,
  terms: null,
  limit: 10,
  page: 0,
  sort: 'name'
};
